import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import axios from "axios";
import VueAxios from "vue-axios";

import jQuery from "jquery";
window.$ = jQuery;


import i18n from "./i18n";

// import Chartkick from 'vue-chartkick'

// import { findPort, findServiceLocation } from "./helpers/Functions";

import moment from 'moment'

Vue.filter('formatDate', function(value) {
  

  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
});

Vue.mixin({
  data: function() {
    return {
      get globalPort() {
        // // // console.log('globalPort ' + window.location.origin);

        // return findPort(window.location.origin);

        // return "1977/api";

        return "api";
      },
      get globalServiceLocation() {
        // // // console.log('globalPort ' + window.location.origin);

        // return findServiceLocation(window.location.origin);
        
        // return "http://gvisp.mkonekt.com:"
        return "https://engine-w.com/"
      }
    }
  }
})

// Vue.use(Chartkick.use(Chart))

export const serverBus = new Vue();


Vue.use(VueAxios, axios);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// import VuetifyOverlay from "vuetify-overlay";
// Vue.use(VuetifyOverlay);

import JsonExcel from 'vue-json-to-excel';
Vue.component('downloadExcel', JsonExcel);


import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { faUserSecret, faBars } from '@fortawesome/free-solid-svg-icons'

// library.add(faUserSecret, faBars)
// Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = true;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
